export default defineNuxtPlugin(() => {
  window.addEventListener('error', event => {
    console.error('🔴 window error:', event.error || event.message)
  })

  window.addEventListener('unhandledrejection', event => {
    console.error('🔴 promise rejection:', event.reason)
  })
})
